module.exports = __webpack_public_path__ + "static/media/rasterFoxResize.b4060528.png";